import styled, { css } from 'styled-components';
import { Button, ButtonLoaderIcon, getToken } from '@optimus-web/core';
import { ToggleButtonProps } from './ToggleButton';

interface ToggleButtonComponentStyledProps extends ToggleButtonProps {
    variant: 'success' | 'tertiary';
}

export const ToggleButtonComponentStyled = styled(Button)`
    ${({ variant, disabled }: ToggleButtonComponentStyledProps) =>
        variant === 'success' &&
        css`
            color: ${getToken('textStaticInverse')};
            background-color: ${getToken('backgroundInteractiveSuccessDefault')};
            border-color: ${getToken('backgroundInteractiveSuccessDefault')};

            &:hover:not([disabled]) {
                color: ${getToken('textStaticInverse')};
                background-color: ${getToken('backgroundInteractiveSuccessHover')};
                border-color: ${getToken('backgroundInteractiveSuccessHover')};
            }

            &:active:enabled {
                color: ${getToken('textStaticInverse')};
                background-color: ${getToken('backgroundInteractiveSuccessActive')};
                border-color: ${getToken('backgroundInteractiveSuccessActive')};
            }

            ${disabled
                ? css`
                      &:disabled {
                          color: ${getToken('textDisabled')};
                          background-color: ${getToken('backgroundDisabled')};
                          border-color: ${getToken('backgroundDisabled')};
                      }
                  `
                : css`
                      ${ButtonLoaderIcon} {
                          path {
                              fill: ${getToken('textStaticInverse')};
                          }
                      }
                  `}
        `}
`;
